// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateReasonForOverride = reason => ({
    reason,
    type: actions.UPDATE_TCSM_LABOR_RATE_REASON_FOR_OVERRIDE
});

export const resetSelectedDealers = () => ({
    type: actions.RESET_TCSM_SELECTED_DEALERS
});

export const updateOverrideEffectiveDate = date => ({
    date,
    type: actions.UPDATE_TCSM_LABOR_RATE_OVERRIDE_EFFECTIVE_DATE
});

export const updateStatus = status => ({
    data: status,
    type: actions.UPDATE_TCSM_LABOR_RATE_STATUS
});

export const updateInternalDeereComments = data => ({
    data,
    type: actions.UPDATE_TCSM_LABOR_RATE_INTERNAL_DEERE_COMMENTS
});

export const updateCommentsToDealer = data => ({
    data,
    type: actions.UPDATE_TCSM_LABOR_RATE_COMMENTS_TO_DEALER
});



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/action-creators/labor-rate.js